import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { VehicleSettlementComponentComponent } from '../../components/vehicle-settlement-component/vehicle-settlement-component.component';
import { ConnectionService } from '../../services/connection.service';
import { LoaderService } from '../../services/loader.service';
import { StorageService } from '../../services/storage.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-vehicle-quote-confirmation',
  templateUrl: './vehicle-quote-confirmation.page.html',
  styleUrls: ['./vehicle-quote-confirmation.page.scss'],
})
export class VehicleQuoteConfirmationPage implements OnInit {
  firstTimeQuoteCall: any = 0;
  iciciConfirmationForm: FormGroup
  basePremium: any;
  minIdv: any;
  maxIdv: any;
  actualValue: any;
  finalPremium: any;
  qutRes: any;
  qtreq: any;
  uptIdv: any;
  cvrAmount: any;
  forPassRes: any;
  addOns: any = []
  qtres: any;
  bgIDV: any;
  actSub: number;
  qtdata: any;
  yesSelected = "section-btn";
  noSelected = "section-btn";
  bonusPremium: any;
  claimPercent: any;
  actualNcbPara: any;
  whenDiscount = 'conf-btn';
  whenDiscountforgarage = 'qut-inp1'
  whenHighlight = 'highlights-btn'
  discountAmt: any;
  noClaimPolicy: any;
  addonsObj = {
    keyProCover: false,
    consumCover: false,
    zdCover: false,
    emergencyCover: false,
    retInvoiceCover: false,
    engineCover: false,
    lopsCover: false,
    engineProd: false,
    rsaValue: 0,
    engineProdValue: 0,
    consProd: false,
    zeroDepProd: '',
    keyProd: '',
    lossProd: '',
    retInvoiceProd: false,
    addRSA: false,
    roadSideAsstCover: '',
    showSheatingCapacity: false,
    showMsg: false,
    antiTheft: false,
    autoAssFlag: false,
    countryExtn: false,
    handicapDisc: false,
    legalPay: false,
    moreVehicle: false,
    electAmt: 0,
    nonElectAmt: 0,
    cngPngAmt: 0,
    countryList: '',
    showNcb: false,
    claimOnPolicy: false,
    unNamePassenger: false,
    validDriving: false,
    vehicleCng: false,
    vehiclePng: false,
    VehCng: false,
    VehPng: false,
    showElecAccess: false,
    showNonElecAccess: false,
    isLegalLiability: false,
    ispaidEmployee: false,
    fiberGlassAddon: false,
    ownerDriver: false,
    hideAddons: false,
    paWaiver: false,
    paShowHide: false,
    ncbDetail: false,
    showIfYes: false,
    ncbShowHide: false,
    hideNCB: false,
    isChecked: true,
    showDiscount: false,
    showCngWhile: false,
    showPngWhile: false,
    showValidDriveLic: false,
    electMoreAmt: false,
    nonelectMoreAmt: false,
    isTenureShow: true,
    vehicleEmeCover: '',
    showRSA: true,
    showEngineProduct: true,
    showRTI: true,
    showKetProtect: true,
    disableElement: false,
    tyreProCover: false,
    tyreProd: false,
    showTyreProduct: true,
    garageCover: false,
    garageProd: false,
    garagePlan: '',
    showGarage: true,
    showEme: true,
    hideConsBonus: false,
    hideKp: false,
    showKeyProt: false,
    zdChanges: false,
    disableAddons: false,
    hideConsKp: false,
    disableRSAAddons: false,
    consChanges: false,
    showLopb: true,
    disabledLopb: false,
    showCons: true,
    hideBonus: false,
  }
  passangerCap: any;
  paTenur: Number = 1;
  businessType: any;
  breakingFlag: any;
  isApprovalRequired: any;
  isQuoteDeviation: any;
  showRtiZd: any;
  ownerTransferDetails: any;
  businessTypeDetails: any;
  depreciationPercent: any;
  triggerSlider: boolean;
  ageOfVehicle: any;
  vehicleSummary = {
    age: 0,
    segment: '',
    vehicleBrand: '',
    vehicleModel: '',
    exShowRoomPrice: 0,
    seatingCapacity: '',
    previousClaim: false,
  };

  constructor(private fb: FormBuilder, private renderer: Renderer2, private loader: LoaderService, private router: Router, private apiService: ConnectionService, private toast: ToastService, private modalCtrl: ModalController, private strg: StorageService) { }

  ngOnInit() {
    this.iciciConfirmationForm = this.fb.group({
      coverAmnt: ['', [Validators.required]],
      policyTerm: ['', [Validators.required]],
      planType: [''],
      zdOptions: [''],
      termAmounts: [''],
      starEmiOption: ['fullPay'],
      updateIdv: [''],
      seatingCap: [''],
      paUnnamed: [''],
      vehiclePngAdd: [''],
      vehicleCngAdd: [''],
      haveNonElecAddon: [''],
      haveElecAddon: [''],
      legalLiability: [''],
      paidEmployee: [''],
      extensionCountries: [''],
      paCoverTenur: ['']
    })
  }
  roadSideCover() {
    this.addonsObj.addRSA = true
    this.addonsObj.roadSideAsstCover = "RSA-Plus"
    this.getPvtQuote(true)
  }

  removeRoadSide() {
    this.addonsObj.addRSA = false;
    this.addonsObj.roadSideAsstCover = "";
    this.getPvtQuote(true)
  }
  engineProduct() {
    this.addonsObj.engineCover = true;
    this.addonsObj.engineProd = true;
    this.getPvtQuote(true)
  }
  removeEngineProduct() {
    this.addonsObj.engineCover = false
    this.addonsObj.engineProd = false;
    this.getPvtQuote(true)
  }
  consAddon() {
    if (this.vehicleSummary.age >= 5 && this.vehicleSummary.age <= 7 && this.vehicleSummary.previousClaim === false) {
      this.addonsObj.hideConsKp = true;
      this.addonsObj.disableElement = true;
      this.addonsObj.disabledLopb = true;
      this.addonsObj.hideConsBonus = true;
      this.addonsObj.disableRSAAddons = true;
    }
    else if (this.vehicleSummary.age <= 5 && this.vehicleSummary.vehicleBrand === 'TOYOTA' || this.vehicleSummary.vehicleBrand === 'FORD' || this.vehicleSummary.vehicleBrand === 'RENAULT' || this.vehicleSummary.vehicleBrand === 'NISSAN' || this.vehicleSummary.vehicleBrand === 'MORRIS GARAGES') {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT";
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.getPvtQuote(true)
    }
    else {
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT";
      this.getPvtQuote(true)
    }
  }
  toChangeConsOptions(e) {
    this.addonsObj.consChanges = true
    if (e.target.value === 'opt1') {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT"
      this.addonsObj.showCons = true;
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.addonsObj.addRSA = true
      this.addonsObj.roadSideAsstCover = "RSA-With Key Protect";
      this.addonsObj.disableElement = false;
      this.addonsObj.disabledLopb = false;
      this.addonsObj.hideConsBonus = true;
    }
    else {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT"
      this.addonsObj.showCons = true;
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.addonsObj.addRSA = true
      this.addonsObj.roadSideAsstCover = "RSA-Plus";
      this.addonsObj.keyProCover = true;
      this.addonsObj.keyProd = "KP2"
      this.addonsObj.disableElement = true
      this.addonsObj.disabledLopb = true
      this.addonsObj.hideConsBonus = true;
      this.addonsObj.hideBonus = false
    }
  }
  removeConsAddon() {
    this.addonsObj.consumCover = false;
    this.addonsObj.consProd = false;
    this.getPvtQuote(true)
  }
  emeCover() {
    this.addonsObj.showSheatingCapacity = true;
    this.addonsObj.emergencyCover = true;
  }
  removeEmeCover() {
    this.addonsObj.showSheatingCapacity = false;
    this.addonsObj.emergencyCover = false;
  }
  vehicleCapacity(e) {
    if (e.target.value > this.vehicleSummary.seatingCapacity) {
      this.iciciConfirmationForm.get('seatingCap').setValue(null)
      this.addonsObj.showMsg = true;
    }
    else {
      this.addonsObj.vehicleEmeCover = "Premium Segment"
      this.passangerCap = this.iciciConfirmationForm.get('seatingCap').value
      this.getPvtQuote(true)
    }
  }

  zeroDep() {
    if (this.vehicleSummary.age <= 5 && this.vehicleSummary.segment === 'Premium Cars C') {
      this.addonsObj.showSheatingCapacity = true;
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT";
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.passangerCap = this.iciciConfirmationForm.get('seatingCap').value
      this.addonsObj.keyProCover = true;
      this.addonsObj.keyProd = "KP1"
      this.addonsObj.lopsCover = false;
      this.addonsObj.lossProd = "PLAN A"
      if (this.iciciConfirmationForm.get('seatingCap').value > this.vehicleSummary.seatingCapacity) {
        this.iciciConfirmationForm.get('seatingCap').setValue(null)
        this.addonsObj.showMsg = true;
      }
      else {
        this.addonsObj.showMsg = false;
      }
    }
    if (this.vehicleSummary.age >= 5 && this.vehicleSummary.age <= 7 && this.vehicleSummary.previousClaim === false) {
      this.addonsObj.hideKp = true;
      this.addonsObj.disableAddons = true;
      this.addonsObj.disableRSAAddons = true;
      this.addonsObj.disableElement = true;
      this.addonsObj.disabledLopb = true;
    }
    else if (this.vehicleSummary.age <= 7 && this.vehicleSummary.vehicleBrand === 'TOYOTA' || this.vehicleSummary.vehicleBrand === 'FORD' || this.vehicleSummary.vehicleBrand === 'RENAULT' || this.vehicleSummary.vehicleBrand === 'NISSAN' || this.vehicleSummary.vehicleBrand === 'MORRIS GARAGES') {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT";
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.getPvtQuote(true)
    }
    else if (this.vehicleSummary.age <= 5 && this.vehicleSummary.vehicleBrand === 'MARUTI' && this.qtreq.isBrandNewVehicle === false) {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT";
      this.addonsObj.addRSA = true;
      this.addonsObj.roadSideAsstCover = "RSA-Plus";
      this.getPvtQuote(true)
    }
    else {
      this.addonsObj.zdCover = true;
      this.addonsObj.lopsCover = true;
      this.addonsObj.keyProCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT";
      this.addonsObj.keyProd = "KP1"
      this.addonsObj.lossProd = "PLAN A"
      this.getPvtQuote(true)
    }
  }
  toChangeZdOptions(e) {
    this.addonsObj.zdChanges = true
    if (e.target.value === 'opt1') {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT"
      this.addonsObj.showCons = true;
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.addonsObj.addRSA = true
      this.addonsObj.roadSideAsstCover = "RSA-With Key Protect";
      this.addonsObj.disableElement = false;
      this.addonsObj.disabledLopb = false;
      this.addonsObj.hideBonus = true;
    }
    else {
      this.addonsObj.zdCover = true;
      this.addonsObj.zeroDepProd = "Silver PVT"
      this.addonsObj.showCons = true;
      this.addonsObj.consumCover = true;
      this.addonsObj.consProd = true;
      this.addonsObj.addRSA = true
      this.addonsObj.roadSideAsstCover = "RSA-Plus";
      this.addonsObj.keyProCover = true;
      this.addonsObj.keyProd = "KP2"
      this.addonsObj.disableElement = true
      this.addonsObj.disabledLopb = true
      this.addonsObj.hideBonus = true;
    }
    if (this.claimPercent > 0) {
      this.getPvtQuote(true)
    }
  }
  bonusClaims(e) {
    if (e.target.value === "0") {
      this.claimPercent = "20";
    }
    else if (e.target.value === "20") {
      this.claimPercent = "25";
    }
    else if (e.target.value === "25") {
      this.claimPercent = "35";
    }
    else if (e.target.value === "35") {
      this.claimPercent = "45";
    }
    else if (e.target.value === "45") {
      this.claimPercent = "50";
    }
    else if (e.target.value === "55") {
      this.claimPercent = "50";
    }
    if (this.addonsObj.zdChanges === true || this.addonsObj.consChanges === true) {
      this.getPvtQuote()
    }
  }
  removeZeroDep() {
    this.addonsObj.zdCover = false;
    this.addonsObj.zeroDepProd = "";
    this.getPvtQuote(true)
  }
  openInfo() {
    if (this.qtreq.isBrandNewVehicle === false) {
      this.addonsObj.showNcb = true;
    } else {
      this.proceedtoProp();
    }
  }
  percentOfClaims(event) {
    if (event.target.value === "0") {
      this.claimPercent = "20";
    }
    else if (event.target.value === "20") {
      this.claimPercent = "25";
    }
    else if (event.target.value === "25") {
      this.claimPercent = "35";
    }
    else if (event.target.value === "35") {
      this.claimPercent = "45";
    }
    else if (event.target.value === "45") {
      this.claimPercent = "50";
    }
    else if (event.target.value === "55") {
      this.claimPercent = "50";
    }
    this.getPvtQuote()
    setTimeout(() => {
      this.closeIt();
      this.proceedtoProp();
    }, 2000);
  }
  closeIt() {
    this.addonsObj.showNcb = false
  }
  noOfClaims(event) {
    this.noClaimPolicy = event.target.value;
    this.getPvtQuote()
    setTimeout(() => {
      this.closeIt();
      this.proceedtoProp();
    }, 2000);
  }
  proceedWithNcb(data) {
    if (data === 'true') {
      this.addonsObj.claimOnPolicy = true;
      this.addonsObj.ncbDetail = true;
      this.addonsObj.showIfYes = true;
      this.yesSelected = "section-btn active-section-btn"
      this.noSelected = "section-btn"
    }
    else if (data === 'false') {
      this.addonsObj.ncbDetail = false;
      this.addonsObj.claimOnPolicy = false
      this.addonsObj.showIfYes = false
      this.yesSelected = "section-btn"
      this.noSelected = "section-btn active-section-btn"
    } else {
      this.claimPercent = "0";
      this.addonsObj.ncbDetail = false;
      this.addonsObj.claimOnPolicy = false
      setTimeout(() => {
        this.closeIt();
        this.proceedtoProp();
      }, 2000);
    }
  }
  seatingCapacity: any = 5;
  getPvtQuote(addons?: boolean) {
    if (this.vehicleSummary.age <= 10 && this.vehicleSummary.segment === 'Premium Cars C') {
      this.addonsObj.lopsCover = true;
      this.addonsObj.keyProCover = true;
      this.addonsObj.keyProd = "KP1"
      this.addonsObj.lossProd = "PLAN A"
      this.addonsObj.disableElement = true;
      this.addonsObj.disabledLopb = true;
    }

    if (this.qtreq.isBrandNewVehicle === true) {
      this.addonsObj.ncbShowHide = false;
      this.qtdata = {
        "fullName": this.qtreq.fullName,
        "email": this.qtreq.email,
        "mobileNumber": this.qtreq.mobileNumber,
        "vehicleRegistrationDate": this.qtreq.vehicleRegistrationDate,
        "isBrandNewVehicle": true,
        "vehicleBrand": this.qtreq.vehicleBrand,
        "vehicleFuelType": this.qtreq.vehicleFuelType,
        "vehicleModel": this.qtreq.vehicleModel,
        "vehicleVariant": "",
        "cityRTO": this.qtreq.cityRTO,
        "vehicleRegistrationNumber": this.qtreq.vehicleRegistrationNumber,
        "policyExpiryDate": this.qtreq.policyExpiryDate,
        "updatedIdvValue": this.uptIdv.toString(),
        "iciciLombardAddOns": {
          "chassisNumber": "",
          "engineNumber": "",
          "firstRegistrationDate": this.qtreq.vehicleRegistrationDate,
          "isPACoverOwnerDriver": this.addonsObj.ownerDriver,
          "isPACoverWaiver": this.addonsObj.paWaiver,
          "paCoverTenure": Number(this.paTenur),
          "isAntiTheftDisc": this.addonsObj.antiTheft,
          "isAutomobileAssocnFlag": this.addonsObj.autoAssFlag,
          "isExtensionCountry": this.addonsObj.countryExtn,
          "extensionCountryName": this.addonsObj.countryList,
          "isHandicapDisc": this.addonsObj.handicapDisc,
          "isLegalLiabilityToPaidDriver": this.addonsObj.legalPay,
          "isMoreThanOneVehicle": this.addonsObj.moreVehicle,
          "isPACoverUnnamedPassenger": this.addonsObj.unNamePassenger,
          "isValidDrivingLicense": this.addonsObj.validDriving,
          "isVehicleHaveCNG": this.addonsObj.vehicleCng,
          "isVehicleHaveLPG": this.addonsObj.vehiclePng,
          "otherDiscount": 0,
          "otherLoading": 0,
          "registrationNumber": this.qtreq.vehicleRegistrationNumber,
          "siHaveElectricalAccessories": this.addonsObj.electAmt,
          "siHaveNonElectricalAccessories": this.addonsObj.nonElectAmt,
          "sipACoverUnnamedPassenger": Number(this.iciciConfirmationForm.get('paUnnamed').value),
          "siVehicleHaveLPG_CNG": Number(this.addonsObj.cngPngAmt),
          "rsaPlanName": this.addonsObj.roadSideAsstCover,
          "isEngineProtectPlus": this.addonsObj.engineProd,
          "zeroDepPlanName": this.addonsObj.zeroDepProd,
          "isConsumables": this.addonsObj.consProd,
          "isRTIApplicableflag": this.addonsObj.retInvoiceCover,
          "keyProtectPlan": this.addonsObj.keyProd,
          "isTyreProtect": this.addonsObj.tyreProd,
          "isGarageCash": this.addonsObj.garageProd,
          "garageCashPlanName": this.addonsObj.garagePlan,
          "lossOfPersonalBelongingPlanName": this.addonsObj.lossProd
        }
      }
    }
    else if (this.qtreq.isBrandNewVehicle === false) {
      this.addonsObj.ncbShowHide = true
      this.qtdata = {
        "fullName": this.qtreq.fullName,
        "email": this.qtreq.email,
        "mobileNumber": this.qtreq.mobileNumber,
        "vehicleRegistrationDate": this.qtreq.vehicleRegistrationDate,
        "isBrandNewVehicle": false,
        "businessType": this.businessTypeDetails,
        "vehicleBrand": this.qtreq.vehicleBrand,
        "vehicleFuelType": this.qtreq.vehicleFuelType,
        "vehicleModel": this.qtreq.vehicleModel,
        "vehicleVariant": "",
        "cityRTO": this.qtreq.cityRTO,
        "vehicleRegistrationNumber": this.qtreq.vehicleRegistrationNumber,
        "policyExpiryDate": this.qtreq.policyExpiryDate,
        "updatedIdvValue": this.uptIdv.toString(),
        "claimOnPreviousPolicy": this.addonsObj.claimOnPolicy,
        "noOfClaimsOnPreviousPolicy": this.noClaimPolicy,
        "bonusOnPreviousPolicy": this.claimPercent,
        "previousPolicyEndDate": this.qtreq.previousPolicyEndDate,
        "previousPolicyStartDate": this.qtreq.previousPolicyStartDate,
        "previousPolicyType": this.qtreq.previousPolicyType,
        "otherDiscount": 0,
        "isNoPrevInsurance": this.qtreq.isNoPrevInsurance,
        "iciciLombardAddOns": {
          "isFiberGlassFuelTank": this.addonsObj.fiberGlassAddon,
          "isHaveElectricalAccessories": this.addonsObj.electAmt,
          "isHaveNonElectricalAccessories": this.addonsObj.nonElectAmt,
          "isEngineProtectPlus": this.addonsObj.engineProd,
          "isLegalLiabilityToPaidEmployee": this.addonsObj.ispaidEmployee,
          "isPACoverOwnerDriver": this.addonsObj.ownerDriver,
          "zeroDepPlanName": this.addonsObj.zeroDepProd,
          "isConsumables": this.addonsObj.consProd,
          "paCoverTenure": 1,
          "isPACoverWaiver": this.addonsObj.paWaiver,
          "isRTIApplicableflag": this.addonsObj.retInvoiceCover,
          "noOfEmployee": Number(this.iciciConfirmationForm.get('paidEmployee').value),
          "emeCover": this.addonsObj.vehicleEmeCover,
          "noOfPassengerHC": Number(this.passangerCap),
          "tPPDLimit": 0,
          "isAntiTheftDisc": this.addonsObj.antiTheft,
          "isAutomobileAssocnFlag": this.addonsObj.autoAssFlag,
          "isExtensionCountry": this.addonsObj.countryExtn,
          "extensionCountryName": this.addonsObj.countryList,
          "isHandicapDisc": this.addonsObj.handicapDisc,
          "isLegalLiabilityToPaidDriver": this.addonsObj.legalPay,
          "isPACoverUnnamedPassenger": this.addonsObj.unNamePassenger,
          "isVehicleHaveCNG": this.addonsObj.vehicleCng,
          "isVehicleHaveLPG": this.addonsObj.vehiclePng,
          "siHaveElectricalAccessories": this.addonsObj.electAmt,
          "siHaveNonElectricalAccessories": this.addonsObj.nonElectAmt,
          "sipACoverUnnamedPassenger": Number(this.iciciConfirmationForm.get('paUnnamed').value),
          "siVehicleHaveLPG_CNG": Number(this.addonsObj.cngPngAmt),
          "rsaPlanName": this.addonsObj.roadSideAsstCover,
          "keyProtectPlan": this.addonsObj.keyProd,
          "isTyreProtect": this.addonsObj.tyreProd,
          "isGarageCash": this.addonsObj.garageProd,
          "garageCashPlanName": this.addonsObj.garagePlan,
          "lossOfPersonalBelongingPlanName": this.addonsObj.lossProd,
          "otherLoading": 0
        }
      }
    }
    if (this.qtdata.claimOnPreviousPolicy === true) {
      this.yesSelected = "section-btn active-section-btn"
      this.noSelected = "section-btn"
      this.addonsObj.showIfYes = true
    }
    else if (this.qtdata.claimOnPreviousPolicy === false) {
      this.noSelected = "section-btn active-section-btn"
      this.yesSelected = "section-btn"
      this.addonsObj.showIfYes = false
    }
    this.loader.showLoader()
    this.apiService.getVehicleQuotePrivate(this.qtdata).subscribe(res => {
      this.loader.hideLoader()
      let qtres = JSON.parse(res.data)
      this.qtres = JSON.parse(res.data)
      this.forPassRes = qtres
      let lombRes = JSON.parse(this.qtres.lombardQuoteResponse.responseParam)
      let lombReqRes = JSON.parse(this.qtres.lombardQuoteResponse.insuranceQuoteRequest.reqParam)
      let lombNoIdvReq = JSON.parse(this.qtres.lombardQuoteResponse.insuranceQuoteRequest.reqParam)
      this.qtres.lombardQuoteResponse.insuranceQuoteRequest.reqParam = lombNoIdvReq;
      let lombNoIdvRes = JSON.parse(this.qtres.lombardQuoteResponse.responseParam)
      this.businessType = qtres.serverQuoteRequest.BusinessType;
      this.breakingFlag = lombRes.breakingFlag;
      this.isApprovalRequired = lombRes.isApprovalRequired;
      this.isQuoteDeviation = lombRes.isQuoteDeviation
      this.vehicleSummary.exShowRoomPrice = lombNoIdvRes.generalInformation.showRoomPrice
      if (this.businessType === 'Roll Over' && this.ownerTransferDetails === true) {
        this.showRtiZd = false
        if (this.addonsObj.zeroDepProd === "Silver PVT" || this.addonsObj.retInvoiceCover === true) {
          this.addonsObj.zeroDepProd = "";
          this.addonsObj.zdCover = false;
          this.addonsObj.lopsCover = false;
          this.addonsObj.lossProd = ""
          this.addonsObj.retInvoiceCover = false
          this.getPvtQuote(true)
          this.showRtiZd = false
        }
      }
      else {
        this.showRtiZd = true
      }
      if ((this.vehicleSummary.age > 7 && this.vehicleSummary.segment != 'Premium Cars C') ||
        (this.vehicleSummary.age > 5 && this.vehicleSummary.vehicleBrand === 'MARUTI') ||
        (this.vehicleSummary.age > 5 && this.vehicleSummary.segment === 'Premium Cars C')) {
        this.showRtiZd = false;
      }
      if (this.vehicleSummary.age > 7) {
        this.addonsObj.showCons = false
      }
      if (this.vehicleSummary.age > 10) {
        this.addonsObj.showRSA = false;
        this.addonsObj.showKetProtect = false;
        this.addonsObj.showGarage = false;
        this.addonsObj.showEme = false
        this.addonsObj.showLopb = false;
      }
      if (this.vehicleSummary.age > 5) {
        this.addonsObj.showEngineProduct = false
      }
      if (this.vehicleSummary.age > 5 || this.breakingFlag === true || this.isApprovalRequired === true || this.isQuoteDeviation === true) {
        this.addonsObj.showRTI = false;
      }
      if (this.vehicleSummary.age > 5 && this.vehicleSummary.segment === 'Premium Cars C' || this.vehicleSummary.age > 3 && this.vehicleSummary.segment != 'Premium Cars C') {
        this.addonsObj.showTyreProduct = false;
      }
      if (this.vehicleSummary.age > 3 && this.vehicleSummary.segment === 'Premium Cars C' && this.vehicleSummary.exShowRoomPrice < 3500000) {
        this.showRtiZd = false;
      }
      this.qutRes = this.qtres
      this.seatingCapacity = lombReqRes?.generalInformation?.seatingCapacity || 5
      this.finalPremium = lombRes.finalPremium;
      let lombIdvDepreciationPercent = qtres.idvResponse.idvdepreciationpercent;
      this.addonsObj.rsaValue = lombNoIdvRes.riskDetails.roadSideAssistance + lombNoIdvRes.riskDetails.engineProtect +
        lombNoIdvRes.riskDetails.consumables + lombNoIdvRes.riskDetails.zeroDepreciation +
        lombNoIdvRes.riskDetails.keyProtect + lombNoIdvRes.riskDetails.lossOfPersonalBelongings +
        lombNoIdvRes.riskDetails.returnToInvoice + lombNoIdvRes.riskDetails.geographicalExtensionOD +
        lombNoIdvRes.riskDetails.geographicalExtensionTP + lombNoIdvRes.riskDetails.paCoverForUnNamedPassenger +
        lombNoIdvRes.riskDetails.fibreGlassFuelTank + lombNoIdvRes.riskDetails.paidDriver +
        lombNoIdvRes.riskDetails.paCoverForOwnerDriver + lombNoIdvRes.riskDetails.biFuelKitTP + lombNoIdvRes.riskDetails.biFuelKitOD
      lombNoIdvRes.riskDetails.electricalAccessories + lombNoIdvRes.riskDetails.nonElectricalAccessories;
      this.discountAmt = lombNoIdvRes.riskDetails.antiTheftDiscount + lombNoIdvRes.riskDetails.handicappedDiscount + lombNoIdvRes.riskDetails.tppD_Discount + lombNoIdvRes.riskDetails.automobileAssociationDiscount + lombNoIdvRes.riskDetails.bonusDiscount
      if (this.discountAmt > 0) {
        this.addonsObj.showDiscount = true;
        this.whenDiscount = 'active-conf-btn'
        this.whenDiscountforgarage = 'active-qut-inp1'
        this.whenHighlight = 'active-highlights-btn'
      }
      else if (this.discountAmt === 0) {
        this.addonsObj.showDiscount = false;
      }
      this.bonusPremium = lombNoIdvRes.riskDetails.ncbPercentage;
      this.basePremium = lombRes.riskDetails.basicOD + lombRes.riskDetails.basicTP + lombRes.totalTax + lombNoIdvRes.riskDetails.breakinLoadingAmount;
      if (!addons) {
        this.minIdv = qtres.idvResponse.minidv;
        this.maxIdv = qtres.idvResponse.maxidv;
        this.actualValue = this.minIdv;
        this.cvrAmount = this.minIdv.toFixed(0)
        let subIDV = 100 - lombIdvDepreciationPercent
      }
      this.bonusPremium = lombNoIdvRes.riskDetails.ncbPercentage;
      this.basePremium = lombRes.riskDetails.basicOD + lombRes.riskDetails.basicTP + lombRes.totalTax + lombNoIdvRes.riskDetails.breakinLoadingAmount;
      if (this.firstTimeQuoteCall === 0) {
        this.minIdv = qtres.idvResponse.minidv;
        this.maxIdv = qtres.idvResponse.maxidv;
        this.actualValue = this.minIdv;
        this.cvrAmount = this.minIdv.toFixed(0)
        let subIDV = 100 - lombIdvDepreciationPercent
        this.uptIdv = ((this.minIdv / (100 - (lombIdvDepreciationPercent * 100))) * 100).toFixed(0)
        this.firstTimeQuoteCall++;
      }
      this.strg.setStoreData('actVal', this.actualValue)
    }, err => {
      this.loader.hideLoader()
    })
  }
  ionViewDidEnter() {
    this.addonsObj.ownerDriver = true;
    this.addonsObj.paWaiver = false;
    this.addonsObj.roadSideAsstCover = ""
    this.addonsObj.engineProd = false;
    this.addonsObj.consProd = false;
    this.addonsObj.retInvoiceProd = false;
    this.addonsObj.keyProd = ""
    this.addonsObj.lossProd = ""
    this.addonsObj.zeroDepProd = "";
    this.addonsObj.countryList = "";
    this.addonsObj.antiTheft = false;
    this.addonsObj.rsaValue = 0
    this.addonsObj.engineProdValue = 0;
    this.addonsObj.autoAssFlag = false;
    this.addonsObj.countryExtn = false;
    this.addonsObj.handicapDisc = false;
    this.addonsObj.legalPay = false;
    this.addonsObj.moreVehicle = false;
    this.addonsObj.unNamePassenger = false;
    this.addonsObj.ispaidEmployee = false;
    this.addonsObj.isLegalLiability = false;
    this.addonsObj.fiberGlassAddon = false;
    this.iciciConfirmationForm.get('paUnnamed').setValue(0);
    this.iciciConfirmationForm.get('paidEmployee').setValue(0);
    this.iciciConfirmationForm.get('legalLiability').setValue(0);
    this.addonsObj.validDriving = false;
    this.addonsObj.vehicleCng = false;
    this.addonsObj.vehiclePng = false;
    this.addonsObj.nonElectAmt = 0;
    this.addonsObj.electAmt = 0;
    this.addonsObj.cngPngAmt = 0;
    this.strg.getStoreData('ic_quotereq').then(resss => {
      this.qtreq = resss;
      if (this.qtreq.isBrandNewVehicle === true) {
        this.addonsObj.hideAddons = true;
        this.addonsObj.isTenureShow = true;
      }
      else if (this.qtreq.isBrandNewVehicle === false) {
        this.addonsObj.hideAddons = false;
        this.addonsObj.isTenureShow = false;
      }

      let dateDiff = getDifferenceInDays(new Date(this.qtreq.previousPolicyEndDate), new Date())
      if (dateDiff <= 90) {
        this.actualNcbPara = "No Claim Bonus (NCB) is a discount proposed to remunerate a vehicle owner who has not claimed the previous policy.NCB moves in fixed slabs of 0%, 20%, 25%, 35%, 45% and 50%, and it leaps to a higher slab every following year without claim. NCB is reset to 0% whenever a claim is made"
      }
      else if (dateDiff > 90) {
        this.actualNcbPara = "Your existing policy lapsed over 90 days back. Therefore, your NCB has been reset to 0%"
        this.addonsObj.hideNCB = true;
      }
      else if (this.qtreq.previousPolicyEndDate === null) {
        this.actualNcbPara = "Since your existing policy details are not available, your NCB has been set to 0%."
      }

      this.strg.getStoreData('quoteres').then(res => {
        let today = new Date().getFullYear()
        let regDate = new Date(this.qtreq.firstRegistrationDate).getFullYear()
        let calcAge = today - regDate
        // let mainIdv = JSON.parse(res[0].data);
        let mainIdv = res[0].data;
        this.bgIDV = mainIdv.idvResponse.minidv;
        this.businessTypeDetails = mainIdv.lombardQuoteRequest.BusinessType
        this.actSub = 100 - mainIdv.idvResponse.idvdepreciationpercent;
        this.depreciationPercent = mainIdv.idvResponse.idvdepreciationpercent;
        this.uptIdv = ((this.bgIDV / (100 - (mainIdv.idvResponse.idvdepreciationpercent * 100))) * 100).toFixed(0)
        this.addonsObj.claimOnPolicy = this.qtreq.claimOnPreviousPolicy;
        this.noClaimPolicy = this.qtreq.noOfClaimsOnPreviousPolicy;
        this.strg.getStoreData('carmodels').then(res => {
          let findSegment = res.carsInfo.find(res => res.vehicleModel === this.qtreq.vehicleModel)
          this.vehicleSummary.vehicleBrand = findSegment.manufacture;
          this.vehicleSummary.vehicleModel = findSegment.vehicleModel;
          this.vehicleSummary.segment = findSegment.segment;
          this.vehicleSummary.seatingCapacity = findSegment.seatingCapacity;
          this.vehicleSummary.age = calcAge;
          this.vehicleSummary.previousClaim = this.addonsObj.claimOnPolicy;
          this.getPvtQuote(false)
        })
      })
    })

  }
  ownerTransfer(event) {
    if (event.target.checked === true) {
      this.businessTypeDetails = "Used"
    }
    else {
      this.businessTypeDetails = "Roll Over"
    }
    this.ownerTransferDetails = event.target.checked
    this.getPvtQuote(true)
  }
  getSliderValue(event) {
    this.actualValue = Number(event.target.value).toFixed(0)
    this.triggerSlider = true
    if (this.actualValue < this.minIdv) {
      this.iciciConfirmationForm.get('updateIdv').setValue(this.minIdv)
      this.actualValue = this.minIdv
    }
    else if (this.actualValue > this.maxIdv) {
      this.iciciConfirmationForm.get('updateIdv').setValue(this.maxIdv)
    }
    this.cvrAmount = Number(event.target.value).toFixed(0)
    Math.round(this.cvrAmount)
    this.uptIdv = ((this.actualValue / (100 - (this.depreciationPercent * 100))) * 100).toFixed(0)
    this.getPvtQuote(true)
  }
  idvChange(e) {
    if (this.iciciConfirmationForm.get('updateIdv').value < this.minIdv) {
      this.toast.showToast('Set within the min and max limt')
    }
    else if (this.iciciConfirmationForm.get('updateIdv').value > this.maxIdv) {
      this.toast.showToast('Set within the min and max limt')
    }
  }
  retInvoice() {
    this.addonsObj.retInvoiceCover = true;
    this.addonsObj.retInvoiceProd = true;
    this.getPvtQuote(true)


  }
  removeretInvoice() {
    this.addonsObj.retInvoiceCover = false;
    this.addonsObj.retInvoiceProd = false;
    this.getPvtQuote(true)
  }
  lopCover() {
    this.addonsObj.lopsCover = true;
    this.addonsObj.lossProd = "PLAN A"
    this.getPvtQuote(true)
  }
  proceedtoProp() {
    let lombQtReq = JSON.parse(this.qutRes.lombardQuoteRequest.reqParam)
    this.qutRes.lombardQuoteRequest.reqParam = lombQtReq;
    let lombRes = JSON.parse(this.qutRes.lombardQuoteResponse.responseParam)
    this.qutRes.lombardQuoteResponse.responseParam = lombRes
    this.qutRes.lombardQuoteResponse.serverQtReq = this.qutRes.serverQuoteRequest
    let data = {
      "productName": 'ICICI Lombord FW',
      "requestObj": this.qutRes.lombardQuoteRequest,
      "responseObj": this.qutRes.lombardQuoteResponse,
    }
    this.strg.setStoreData('updatedIdv', this.uptIdv)
    this.strg.setStoreData('icici_finalRes', this.qutRes)
    this.strg.setStoreData('addonstoprc', this.qtdata)
    this.loader.showLoader()
    this.apiService.saveFinalQuotation(data).subscribe(res => {
      this.loader.hideLoader()
      this.strg.setStoreData("vhIncp", false);
      // this.router.navigate(["/vehicle-proposal-form"])
      this.redirectToLombardKyc();
    })
  }

  redirectToLombardKyc() {
    this.router.navigate(["/lombard-ckyc/1"])
  }

  removeLopCover() {
    this.addonsObj.lopsCover = false;
    this.addonsObj.lossProd = ""
    this.getPvtQuote(true)
  }
  keyCover() {
    this.addonsObj.showKeyProt = true
    this.addonsObj.keyProCover = true
  }
  changePlan(e) {
    this.addonsObj.keyProd = e.target.value
    this.getPvtQuote(true)
  }
  tyreProduct() {
    this.addonsObj.tyreProCover = true;
    this.addonsObj.tyreProd = true;
    this.getPvtQuote(true);
  }
  removeTyreProduct() {
    this.addonsObj.tyreProCover = false;
    this.addonsObj.tyreProd = false;
    this.getPvtQuote(true);
  }
  garageCash() {
    this.addonsObj.garageCover = true;
    this.addonsObj.garageProd = true;
    this.addonsObj.garagePlan = "Rs 500 per day for 14 days";
    this.getPvtQuote(true);
  }
  removeGarageCash() {
    this.addonsObj.garageCover = false;
    this.addonsObj.garageProd = false;
    this.addonsObj.garagePlan = "";
    this.getPvtQuote(true);
  }
  removeKeyCover() {
    this.addonsObj.showKeyProt = false;
    this.addonsObj.keyProCover = false;
    this.addonsObj.keyProd = "";
    this.getPvtQuote(true)
  }
  antiTheftCover() {
    this.addonsObj.antiTheft = true;
    this.getPvtQuote(true)

  }
  removeAntiTheft() {
    this.addonsObj.antiTheft = false;
    this.getPvtQuote(true)
  }
  autoAssFlagCover() {
    this.addonsObj.autoAssFlag = true;
    this.getPvtQuote(true)
  }
  removeautoAssFlag() {
    this.addonsObj.autoAssFlag = false;
    this.getPvtQuote(true)
  }
  showExtCountryOptions: boolean = false;
  countryExtnCover() {
    this.showExtCountryOptions = true;
    if (this.iciciConfirmationForm.get('extensionCountries').value != "" || this.iciciConfirmationForm.get('extensionCountries').value != null) {
      this.addonsObj.countryExtn = true;
    } else {
      this.addonsObj.countryExtn = false;
    }
  }
  extensionList() {
    this.addonsObj.countryList = this.iciciConfirmationForm.get('extensionCountries').value
    this.addonsObj.countryExtn = true;
    this.getPvtQuote(true)
  }
  removeCountryExtn() {
    this.addonsObj.countryExtn = false;
    this.showExtCountryOptions = false;
    this.addonsObj.countryList = "No Extension";
    this.getPvtQuote(true)
  }
  handicapDiscCover() {
    this.addonsObj.handicapDisc = true;
    this.getPvtQuote(true)
  }
  removeHandicapDisc() {
    this.addonsObj.handicapDisc = false;
    this.getPvtQuote(true)
  }
  legalPayCover() {
    this.addonsObj.legalPay = true;
    this.getPvtQuote(true)
  }
  removeLegalPay() {
    this.addonsObj.legalPay = false;
    this.getPvtQuote(true)
  }
  moreVehicleCover() {
    this.addonsObj.moreVehicle = true;
    this.getPvtQuote(true)
  }
  removeMoreVehicle() {
    this.addonsObj.moreVehicle = false;
    this.getPvtQuote(true)
  }
  unNamePassengerCover() {
    this.addonsObj.unNamePassenger = true;
    this.iciciConfirmationForm.get("paUnnamed").setValue(Number(this.seatingCapacity) * 100000);
    this.getPvtQuote(true)
  }
  legalLiabilityAddon() {
    this.getPvtQuote(true)
  }
  legalLiabilityCover() {
    this.addonsObj.isLegalLiability = true;
  }
  removeLegalLiabilityCover() {
    this.addonsObj.isLegalLiability = false;
    this.iciciConfirmationForm.get('legalLiability').setValue(0)
    this.getPvtQuote(true);
  }
  ispaidEmployeeCover() {
    this.addonsObj.ispaidEmployee = true;
  }
  paidEmployeeAddon() {
    if (this.iciciConfirmationForm.get('paidEmployee').value >= 1) {
      this.getPvtQuote(true)
    }
  }
  removePaidEmployee() {
    this.addonsObj.ispaidEmployee = false;
    this.iciciConfirmationForm.get('paidEmployee').setValue(0)
    this.getPvtQuote(true);
  }
  removeUnNamePassenger() {
    this.addonsObj.unNamePassenger = false;
    this.iciciConfirmationForm.get('paUnnamed').setValue(0)
    this.getPvtQuote(true)
  }
  validDrivingCover() {
    this.addonsObj.validDriving = true;
    this.getPvtQuote(true)
  }
  removeValidDriving() {
    this.addonsObj.validDriving = false;
    this.getPvtQuote(true)
  }
  vehicleCngCover() {
    this.addonsObj.VehCng = true;
    this.addonsObj.vehicleCng = true;
  }

  removeVehicleCngCover() {
    this.addonsObj.VehCng = false;

    this.getPvtQuote(true)
  }
  vehiclePngCover() {
    this.addonsObj.VehPng = true;

  }
  pngAddon() {
    this.getPvtQuote(true)
  }
  removeVehiclePngCover() {
    this.addonsObj.VehPng = false;
    this.getPvtQuote(true)
  }
  haveElectAccss() {
    this.getPvtQuote(true)
  }
  haveNonElectAccss() {
    this.getPvtQuote(true)
  }
  validDrive(e) {
    if (e.target.checked === true) {
      this.addonsObj.validDriving = true;
      this.getPvtQuote(true)
    }
    else if (e.target.checked === false) {
      this.addonsObj.validDriving = false;
      this.getPvtQuote(true)
    }
  }
  paCoverForOwnerDriver(e) {
    if (e.target.checked === true) {
      this.addonsObj.ownerDriver = true;
      this.addonsObj.paWaiver = false;
      this.addonsObj.paShowHide = false;
      this.addonsObj.isChecked = false;
      if (this.qtreq.isBrandNewVehicle === true) {
        this.addonsObj.isTenureShow = true;
      } else if (this.qtreq.isBrandNewVehicle === false) {
        this.addonsObj.isTenureShow = false;
      }
      this.addonsObj.showValidDriveLic = false;
      this.getPvtQuote(true)
    }
    else if (e.target.checked === false) {
      this.addonsObj.ownerDriver = false;
      this.addonsObj.paShowHide = true;
      this.addonsObj.paWaiver = true;
      this.addonsObj.isTenureShow = false;
    }
  }
  confirmNo() {
    this.addonsObj.paShowHide = false;
    this.addonsObj.isChecked = true
    if (this.qtreq.isBrandNewVehicle === true) {
      this.addonsObj.isTenureShow = true;
    } else if (this.qtreq.isBrandNewVehicle === false) {
      this.addonsObj.isTenureShow = false;
    }
    this.addonsObj.showValidDriveLic = false;
  }
  confirmYes() {
    this.addonsObj.ownerDriver = false;
    this.addonsObj.paShowHide = false;
    this.addonsObj.showValidDriveLic = true;
    this.getPvtQuote(true)
  }
  changePaTenur(event) {
    this.paTenur = event.target.value
    this.getPvtQuote(true)
  }
  fiberGlass(e) {
    if (e.target.checked === true) {
      this.addonsObj.fiberGlassAddon = true;
      this.getPvtQuote(true)
    }
    else if (e.target.checked === false) {
      this.addonsObj.fiberGlassAddon = false;
      this.getPvtQuote(true);
    }
  }
  electAccess(e) {
    if (e.target.checked === true) {
      this.addonsObj.showElecAccess = true;
      if (this.iciciConfirmationForm.get('haveElecAddon').value != 0) {
        this.getPvtQuote();
      }
    }
    else if (e.target.checked === false) {
      this.addonsObj.showElecAccess = false;
      this.addonsObj.electAmt = 0;
      this.addonsObj.electMoreAmt = false;
      this.getPvtQuote();
    }

  }
  haveElect() {
    this.addonsObj.electAmt = Number(this.iciciConfirmationForm.get('haveElecAddon').value)
    if (this.addonsObj.electAmt > 4396839) {
      this.addonsObj.electMoreAmt = true;
      this.iciciConfirmationForm.get('haveElecAddon').setValue(0)
    }
    else if (this.addonsObj.electAmt >= 10) {
      this.addonsObj.electMoreAmt = true;
      this.getPvtQuote();
    }
  }
  nonElectAccess(e) {
    if (e.target.checked === true) {
      this.addonsObj.showNonElecAccess = true;
      if (this.iciciConfirmationForm.get('haveNonElecAddon').value != 0) {
        this.getPvtQuote()
      }
    }
    else if (e.target.checked === false) {
      this.addonsObj.showNonElecAccess = false;
      this.addonsObj.nonelectMoreAmt = false;
      this.addonsObj.nonElectAmt = 0;
      this.getPvtQuote()
    }
  }
  haveNonElect() {
    this.addonsObj.nonElectAmt = Number(this.iciciConfirmationForm.get('haveNonElecAddon').value)
    if (this.addonsObj.nonElectAmt > 4396839) {
      this.addonsObj.nonelectMoreAmt = true;
      this.iciciConfirmationForm.get('haveNonElecAddon').setValue(0)
    }
    if (this.addonsObj.nonElectAmt >= 10000) {
      this.getPvtQuote()
    }
  }
  lpgAccess(e) {
    if (e.target.checked === true) {
      this.addonsObj.VehPng = true;
      this.addonsObj.showCngWhile = true;
      this.addonsObj.vehiclePng = true
      this.getPvtQuote()

    }
    else if (e.target.checked === false) {
      this.addonsObj.VehPng = false;
      this.addonsObj.vehiclePng = false;
      this.addonsObj.showCngWhile = false;
      this.addonsObj.cngPngAmt = 0;
      this.getPvtQuote()

    }
  }
  cngAddon(e) {
    this.addonsObj.cngPngAmt = Number(this.iciciConfirmationForm.get('vehicleCngAdd').value)
    if (this.addonsObj.cngPngAmt > 0) {
      this.getPvtQuote(true)
    }
  }
  cngAccess(e) {
    if (e.target.checked === true) {
      this.addonsObj.VehCng = true;
      this.addonsObj.showPngWhile = true;
      this.addonsObj.vehicleCng = true
      this.getPvtQuote()

    }
    else if (e.target.checked === false) {
      this.addonsObj.VehCng = false;
      this.addonsObj.showPngWhile = false;
      this.addonsObj.vehicleCng = false;
      this.addonsObj.cngPngAmt = 0;
      this.getPvtQuote()

    }
  }
  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }
  async openConfirmModal(cashless) {
    const modal = await this.modalCtrl.create({
      component: VehicleSettlementComponentComponent,
      componentProps: {
        dataSelected: this.forPassRes,
        cashlessOpen: cashless,
      },
      cssClass: "modal-settlement",
      showBackdrop: false,
      backdropDismiss: false,
      swipeToClose: true
    });
    modal.onDidDismiss().then((isOkay) => {
    });
    return await modal.present();
  }
}
function getDifferenceInDays(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60 * 24);
}
